/** Safe JSON.parse for sessionStorage values (empty string throws without this). */
export function parseSessionJson<T>(raw: string | null | undefined, fallback: T): T {
  if (raw === null || raw === undefined) {
    return fallback;
  }
  const trimmed = String(raw).trim();
  if (trimmed === "" || trimmed === "null" || trimmed === "undefined") {
    return fallback;
  }
  try {
    return JSON.parse(trimmed) as T;
  } catch {
    return fallback;
  }
}
